import React, { useEffect, useState, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Card, Typography, Box } from '@material-ui/core'
import SimpleCesiumFallback from '../../components/TruckMap3D/TruckMap3D'
import { AppContainer } from './CesiumMap.styles'
import useMapEligibility from '../../config/store/hooks'
import MapBlocker from './MapBlocker'
import { onGetCesiumThunk } from './CesiumMap.actions'
import { Map } from '@material-ui/icons'

const CesiumV2 = () => {
  const dispatch = useDispatch()
  const [checkNonce, setCheckNonce] = useState(0)
  const { ok, missing, hints } = useMapEligibility()

  // Get Cesium data from Redux
  const { urlData: trucks, error } = useSelector(state => state.cesium)
  // Fetch via thunk
  useEffect(() => {
    dispatch(onGetCesiumThunk())
    const interval = setInterval(() => dispatch(onGetCesiumThunk()), 60000)
    return () => clearInterval(interval)
  }, [dispatch])

  // Adapt data shape for Cesium component
  const adaptedTrucks = useMemo(() => {
    return trucks.map((t, idx) => ({
      id: t.equipo || `truck-${idx}`,
      name: t.equipo || `Truck ${idx}`,
      lat: Number(t.latitude),
      lon: Number(t.longitude),
      altitude: Number(t.cota) || 0,
      speed: Number(t.velocidad) || 0,
      driver: t.operador && t.operador !== 'nan' ? t.operador : 'Sin Operador',
      type: t.equipment_type || 'Desconocido',
      model: t.turno || '-',
      lastUpdate: t.date_gps || t.date || null,
      heading: 0,
      status: Number(t.velocidad) > 0 ? 'Operativo' : 'Detenido'
    }))
  }, [trucks])

  return (
    <>
      <Card
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          p: 2
        }}
      >
        <Map fontSize="small" />
        <Typography variant="subtitle2">MAPA - TIEMPO REAL</Typography>
      </Card>

      {!ok ? (
        <MapBlocker key={checkNonce} missing={missing} hints={hints} onRetry={() => setCheckNonce(n => n + 1)} />
      ) : (
        <>
          {error && (
            <Box p={2}>
              <Typography color="error">Error al cargar datos del mapa</Typography>
            </Box>
          )}

          <Card sx={{ p: 0 }}>
            <AppContainer>
              <SimpleCesiumFallback trucks={adaptedTrucks} imageryId={3889253} terrainId={3885383} />
            </AppContainer>
          </Card>
        </>
      )}
    </>
  )
}

export default CesiumV2
